module.exports = __webpack_public_path__ + "static/img/has-body-icon.1335b7a1.png";